import React from "react";
import RoomAssignmentBoard from "./RoomAssignmentBoard";
import { ExpertMinumimFixedUsers, ExpertRole } from "../../data/constants";
import TranslatedMessage from "../translations/TranslatedMessage";

const ProctorsOralPreparationAssignmentBoard: React.FunctionComponent = () => {
  return (
    <RoomAssignmentBoard
      minimumFixedUsers={ExpertMinumimFixedUsers.proctorOralPreparation}
      assignPreparationRooms={true}
      fixedExpertsLabel={<TranslatedMessage id="userRoomAssignment.label.fixedProctors" />}
      fixedExpertsPlaceholder={<TranslatedMessage id="userRoomAssignment.placeholder.selectFixedProctors" />}
      reserveExpertsLabel={<TranslatedMessage id="userRoomAssignment.label.reserveProctors" />}
      reserveExpertsPlaceholder={<TranslatedMessage id="userRoomAssignment.placeholder.selectReserveProctors" />}
      expertRole={ExpertRole.Aufsichtsexperten}
    />
  );
};

export default ProctorsOralPreparationAssignmentBoard;
